<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters" style="display: flex;justify-content: space-between;">
        <el-form :inline="true" label-width="50px" label-position="left">
          <el-form-item :label="$t('Partners.postCode')">
            <el-input
              v-model="filter.code"
              :placeholder="$t('CargoMsg.Cargo_PlsInput') + $t('Partners.postCode')"
              style="width: 165px"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CityP')">
            <el-input
              v-model="filter.city"
              :placeholder="$t('CargoMsg.Cargo_PlsInput') + $t('CargoMsg.Cargo_CityP')"
              style="width: 165px"
            />
          </el-form-item>
          <el-form-item :label="$t('Message.State')">
            <el-input
              v-model="filter.state"
              :placeholder="$t('CargoMsg.Cargo_PlsInput') + $t('Message.State')"
              style="width: 165px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="onAdd()">{{ $t('common.btn.new') + $t('CargoMsg.Cargo_UsPostalCode') }}</el-button>
        <!--        <el-button no="exportExcel" type="primary" @click="exportExcel">{{ $t('common.btn.exportExcel') }}</el-button>-->
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleTabClick">
        <el-tab-pane :label="$t('CargoMsg.Cargo_UsPostalCode')" name="tabUsPostalCode">
          <div class="app-main-inner-row row-grid">
            <cargo-ag-grid
              config-module="101412"
              :grid-params.sync="girdParams"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              style="height: 320px"
            />
          </div>
          <div class="app-main-inner-row row-pagination">
            <cargo-pagination
              v-show="total>0"
              :total="total"
              :page.sync="filter.pageNum"
              :limit.sync="filter.pageSize"
              @pagination="toQuery"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="postalCodeDialog.visible"
      :title="postalCodeDialog.title"
      width="450px"
      style="font-size: 16px"
      :close-on-click-modal="false"
    >
      <div class="editDialog" style="padding: 10px 0 10px 0;">
        <el-form label-position="left" class="form-item-200">
          <el-form-item :label="$t('Partners.postCode')" label-width="50px" :required="true">
            <el-input v-model="postalCodeDialog.form.code" style="width: 310px" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_city')" label-width="50px" :required="true">
            <el-input v-model="postalCodeDialog.form.city" style="width: 310px" />
          </el-form-item>
          <el-form-item :label="$t('Message.State')" label-width="50px" :required="true">
            <el-input v-model="postalCodeDialog.form.state" style="width: 310px" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.city.lat')" label-width="50px">
            <el-input v-model="postalCodeDialog.form.latitude" style="width: 310px" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.city.lon')" label-width="50px">
            <el-input v-model="postalCodeDialog.form.longitude" style="width: 310px" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="postalCodeDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { DocumentManage } from '@/utils/commonUtil'
import { delPostalCode, getPostalCodeList, savePostalCode } from '@/api/basicData/postalCode'

export default {
  name: 'PostalCode',
  components: { cargoAdvanceSelect },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      filter: {
        code: '',
        city: '',
        state: '',
        country: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [] // 去掉每列的菜单
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Partners.postCode'),
          field: 'code',
          colId: 'code',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_city'),
          field: 'city',
          colId: 'city',
          width: 200
        },
        {
          headerName: this.$t('Message.State'),
          field: 'state',
          colId: 'state',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.city.lat'),
          field: 'latitude',
          colId: 'latitude',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.city.lon'),
          field: 'longitude',
          colId: 'longitude',
          width: 200
        },
        {
          headerName: this.$t('SeaExport.Operation'),
          field: 'operation',
          suppressMenu: true,
          width: 140,
          cellRenderer: params => {
            const onEdit = this.documentManage.getPath('onEdit')
            const onDel = this.documentManage.getPath('onDel')
            return `<div>
                        <a onclick="${onEdit}('${params.data.uuid}')" style="color:#1F75D5;font-size:12px;">${this.$t('CargoMsg.Cargo_Edit')}</a>
                        <a onclick="${onDel}('${params.data.uuid}')" style="color:red;font-size:12px;">${this.$t('CargoMsg.Cargo_Delete')}</a>
                      </div>`
          }
        }
      ],
      rowData: null,
      country: 'US',
      activeTabName: 'tabUsPostalCode',
      documentManage: new DocumentManage(),
      postalCodeDialog: {
        visible: false,
        title: '',
        isEdit: false,
        form: {
          uuid: '',
          code: '',
          state: '',
          city: '',
          country: '',
          latitude: '',
          longitude: ''
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onEdit', function(value) {
      context.onEdit(value)
    })
    this.documentManage.set('onDel', function(value) {
      context.onDel(value)
    })
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getPostalCodeList(self.filter).then(res => {
        self.rowData = res.data.list
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    onDel(uuid) {
      const self = this
      if (!uuid) {
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        delPostalCode(uuid).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
        }).catch(() => {})
      })
    },
    onAdd() {
      this.showEditDialog(true, true, null)
    },
    onEdit(uuid) {
      this.showEditDialog(false, true, uuid)
    },
    async showEditDialog(isNew, isEdit, uuid = null) {
      if (isNew) {
        this.postalCodeDialog.form = {
          uuid: '',
          code: '',
          state: '',
          city: '',
          country: this.country,
          latitude: '',
          longitude: ''
        }
        this.postalCodeDialog.isEdit = true
        this.postalCodeDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_UsPostalCode')
        this.postalCodeDialog.visible = true
      } else {
        if (!uuid || uuid.length === 0) {
          return
        }
        const postalCode = this.rowData.find(p => p.uuid === uuid)
        if (postalCode) {
          this.postalCodeDialog.form = postalCode
          this.postalCodeDialog.isEdit = isEdit
          this.postalCodeDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_UsPostalCode')
          this.postalCodeDialog.visible = true
        }
      }
    },
    save() {
      const self = this
      const form = self.postalCodeDialog.form
      if (!form.code) {
        self.$message.warning(self.$t('Partners.postCode') + self.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!form.city) {
        self.$message.warning(self.$t('CargoMsg.Cargo_city') + self.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!form.state) {
        self.$message.warning(self.$t('Message.State') + self.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      form.country = this.country
      const loading = getLoading()
      savePostalCode(form).then(res => {
        self.toQuery()
        self.postalCodeDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.postalCodeDialog.visible = false
      }).finally(() => loading.close())
    },
    handleTabClick() {

    },
    exportExcel() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          self.$t('Partners.postCode'),
          self.$t('CargoMsg.Cargo_city'),
          self.$t('Message.State'),
          self.$t('baseInfo.city.lat'),
          self.$t('baseInfo.city.lon')
        ]
        const filterVal = ['code', 'city', 'state', 'latitude', 'longitude']
        const data = self.formatJson(filterVal, rows)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'PostalCode'
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
}
</script>

<style scoped lang="scss">
.el-dialog__title {
  font-size: 15px;
}
</style>
